import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { EquipmentRequestsPage } from '@/features/resources/equipment-requests-page';

const searchSchema = z.object({ request: z.string().optional().catch(undefined) });

export const Route = createFileRoute('/_app/projects/$projectId/resources/equipment-requests')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <EquipmentRequestsPage projectId={projectId} requestId={search.request} />;
}
